import { render } from "./FrontEnd.vue?vue&type=template&id=2e78d870&scoped=true"
import script from "./FrontEnd.vue?vue&type=script&lang=js"
export * from "./FrontEnd.vue?vue&type=script&lang=js"

import "./FrontEnd.vue?vue&type=style&index=0&id=2e78d870&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e78d870"]])

export default __exports__